import React from 'react'

type UploadButtonProps = {
  id: string
  name?: string
  label?: string
  accept?: string
  disabled?: boolean
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
}

export const UploadButton: React.FC<UploadButtonProps> = ({
  id,
  name,
  label = '',
  accept,
  disabled = false,
  onChange,
  ...props
}) => {
  return (
    <label htmlFor={id}>
      <span className="ml-5 rounded-md border border-gray-300 bg-white py-2 px-3 text-sm font-medium leading-4 text-gray-700 shadow-sm cursor-pointer hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:ring-offset-2">
        {label}
      </span>
      <input
        {...props}
        id={id}
        name={name}
        accept={accept}
        onChange={onChange}
        type="file"
        className="sr-only"
        disabled={disabled}
      />
    </label>
  )
}
